/**
 * Команды игрока в бою. Это единственный ввод engine: всё остальное выводится из сида и состояния забежки,
 * поэтому сервер повторяет волну по списку команд с тиками ({@link TimedCommand}) и получает тот же итог.
 *
 * Клиент (I1) кладёт команду в очередь engine; engine применяет её в начале указанного тика.
 */
import { z } from "zod";
import { ContentId, EntityId, HeroId, Tick } from "./common";

/** Нажать кнопку навыка героя. Не готов или героя нет — engine игнорирует (и сервер тоже). */
export const CastSkillCommand = z.object({
  type: z.literal("castSkill"),
  heroId: HeroId,
});

/** Включить или выключить «Автонавыки» (только VIP, MADR 0003). */
export const SetAutoSkillsCommand = z.object({
  type: z.literal("setAutoSkills"),
  enabled: z.boolean(),
});

/**
 * Выбор усиления «1 из 3» после пройденной волны. Пишется последней командой журнала этой волны
 * (тик — не меньше `result.ticks`). `index` — позиция в предложении, `boostId` — для сверки:
 * сервер сам строит предложение из сида волны и проверяет, что выбранное в нём есть.
 */
export const ChooseBoostCommand = z.object({
  type: z.literal("chooseBoost"),
  index: z.number().int().min(0).max(2),
  boostId: ContentId,
});

/** Тап по посылке. Посылки нет на этом тике (исчезла, уже открыта) — engine игнорирует (и сервер тоже). */
export const TapParcelCommand = z.object({
  type: z.literal("tapParcel"),
  parcelId: EntityId,
});

/** Любая команда игрока. */
export const PlayerCommand = z.discriminatedUnion("type", [
  CastSkillCommand,
  SetAutoSkillsCommand,
  ChooseBoostCommand,
  TapParcelCommand,
]);
export type PlayerCommand = z.infer<typeof PlayerCommand>;
export type PlayerCommandType = PlayerCommand["type"];

/** Команда с тиком применения (тик от начала волны). */
export const TimedCommand = z.object({
  tick: Tick,
  command: PlayerCommand,
});
export type TimedCommand = z.infer<typeof TimedCommand>;
